/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bakery_Home_Hero_TextInputs */

const en_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bake cakes with your daily focus and collect 11 limited surprises!`)
};

const ar_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اخبز الكعكات بتركيزك اليومي واجمع 11 مفاجأة محدودة!`)
};

const de_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backe Kuchen mit deinem täglichen Fokus und sammle 11 limitierte Überraschungen!`)
};

const es_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Hornea pasteles con tu concentración diaria y colecciona 11 sorpresas limitadas!`)
};

const fr_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparez des gâteaux avec votre concentration quotidienne et collectionnez 11 surprises limitées !`)
};

const it_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepara torte con la tua concentrazione quotidiana e colleziona 11 sorprese limitate!`)
};

const ja_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日の集中でケーキを焼き、11種類の限定サプライズを集めましょう！`)
};

const ko_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매일 집중하여 케이크를 굽고 11가지 한정 서프라이즈를 모아보세요!`)
};

const pt_br_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asse bolos com seu foco diário e colecione 11 surpresas limitadas!`)
};

const ru_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пеките торты, используя ежедневную концентрацию, и соберите 11 лимитированных сюрпризов!`)
};

const th_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อบเค้กด้วยการโฟกัสในแต่ละวันและสะสม 11 เซอร์ไพรส์สุดพิเศษ!`)
};

const tr_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük odağınızla pastalar pişirin ve 11 sınırlı sürprizi toplayın!`)
};

const zh_cn_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用每日专注烘焙蛋糕，收集 11 款限定惊喜！`)
};

const zh_tw_bakery_home_hero_text = /** @type {(inputs: Bakery_Home_Hero_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用每日專注烘焙蛋糕，收集 11 款限定驚喜！`)
};

/**
* | output |
* | --- |
* | "Bake cakes with your daily focus and collect 11 limited surprises!" |
*
* @param {Bakery_Home_Hero_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const bakery_home_hero_text = /** @type {((inputs?: Bakery_Home_Hero_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bakery_Home_Hero_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bakery_home_hero_text(inputs)
	if (locale === "ar") return ar_bakery_home_hero_text(inputs)
	if (locale === "de") return de_bakery_home_hero_text(inputs)
	if (locale === "es") return es_bakery_home_hero_text(inputs)
	if (locale === "fr") return fr_bakery_home_hero_text(inputs)
	if (locale === "it") return it_bakery_home_hero_text(inputs)
	if (locale === "ja") return ja_bakery_home_hero_text(inputs)
	if (locale === "ko") return ko_bakery_home_hero_text(inputs)
	if (locale === "pt_br") return pt_br_bakery_home_hero_text(inputs)
	if (locale === "ru") return ru_bakery_home_hero_text(inputs)
	if (locale === "th") return th_bakery_home_hero_text(inputs)
	if (locale === "tr") return tr_bakery_home_hero_text(inputs)
	if (locale === "zh_cn") return zh_cn_bakery_home_hero_text(inputs)
	return zh_tw_bakery_home_hero_text(inputs)
});